//新しいキーと作成済みのキーを比較
const deepDiff = (oldObj, newObj) => {
  const values = {
    VALUE_CREATED: 'created',
    VALUE_UPDATED: 'updated',
    VALUE_DELETED: 'deleted',
    VALUE_UNCHANGED: 'unchanged'
  }
  const map = (oldObj, newObj) => {
    if (isValue(oldObj) || isValue(newObj)) {
      return {
        type: compareValues(oldObj, newObj),
        data: (oldObj === undefined) ? newObj : oldObj
      }
    }
    let diff = {}

    for (let key in oldObj) {
      let value2
      if ('undefined' !== typeof(newObj[key])) {
        value2 = newObj[key]
      }
      diff[key] = map(oldObj[key], value2)
    }
    for (let key in newObj) {
      if ('undefined' !== typeof(diff[key])) continue
      diff[key] = map(undefined, newObj[key])
    }
    return diff
  }
  const compareValues = (value1, value2) => {
    if (value1 === value2) return values.VALUE_UNCHANGED
    if ('undefined' === typeof(value1)) return values.VALUE_CREATED
    if ('undefined' === typeof(value2)) return values.VALUE_DELETED
    return values.VALUE_UPDATED
  }
  const isArray = (obj) => {return {}.toString.apply(obj) === '[object Array]'}
  const isObject = (obj) => {return {}.toString.apply(obj) === '[object Object]'}
  const isValue = (obj) => {return !isObject(obj) && !isArray(obj)}

  return map(oldObj, newObj)
}

export const initInputKeys = (targetJson, inputKeys) => {
  let newKeys = {}
  const keyList = []

  //ネストされたJSONを再帰的に処理 -> キー取り出し
  const recursion = (obj) => {
    for (let key in obj) {
      if (typeof obj !== 'string') keyList.push(key)

      if (typeof obj[key] === 'object') {
        if (Array.isArray(obj[key])) {
          obj[key].forEach(item => recursion(item))
        } else {
          if (obj[key]) Object.keys(obj[key]).map(v => keyList.push(v))
          recursion(obj[key])
        }
      }
    }
  }

  recursion(targetJson)

  if (keyList.length > 0) {
    keyList.forEach(key => {
      if (isNaN(Number(key))) {
        newKeys = Object.assign({}, newKeys, {[key]: {vocabulary: '', property: ''}})
      }
    })

    deepDiff(inputKeys, newKeys)
  }

  return newKeys
}

export const getContextKeys = (inputKeys, vocabulary) => {
  let keys = {}
  Object.keys(inputKeys).forEach(key => {
    if (isNaN(Number(key)) && vocabulary.match.find(w => w.inputKey === key)) {
      const index = vocabulary.match.findIndex(w => w.inputKey === key)
      keys[key] = {property: vocabulary.match[index].value}
    }
  })
  return keys
}

export const getGistList = (user) => {
  const url = user.userUrl + '/gists'
  return new Promise((resolve, reject) => {
    fetch(url).then(result => {
      if (result.ok) {
        return result.json()
      } else {
        throw new Error('Network Error')
      }
    }).then(result => {
      const contexts = []
      Object.keys(result).forEach((key, i) => {
        const file = (result[key])
        if(file.files['json2ld-context.json']){
          contexts.push({
            'name': file.description,
            'type': 'gist',
            'uri': file.files['json2ld-context.json'].raw_url ,
            'checked': false
          })
        }
      })
      resolve(contexts)
    }).catch(error => {
      console.log(error)
      reject(error)
    })
  })
}

export const getContextFromGist = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url).then(result => {
      if (result.ok) {
        return result.json()
      } else {
        throw new Error('Network Error')
      }
    }).then(result => {
      resolve(result)
    }).catch(error => {
      (console.log(error))
      reject(error)
    })
  })
}

export const getContextVocabularies = (props) => {
  return new Promise((resolve, reject) => {
    const countResult = []
    if (props.vocabularies.length > 0) {
      props.vocabularies.forEach((v, i) => {
        const name = v.name
        const resultObj = {name: '', hit: 0, match: []}
        let hitSearch = 0
        const properties = v.properties
        Object.keys(properties).forEach(key => {
          if (Object.keys(props.inputKeys).find(x => x === key)) {
            hitSearch++
            resultObj.match.push({inputKey: key, value: properties[key]})
          }
        })
        resultObj.type = 'vocabulary'
        resultObj.uri = v.url
        resultObj.name = name
        resultObj.hit = hitSearch
        resultObj.checked = i === 0
        resultObj.properties = properties
        resultObj.types = v.types
        countResult.push(resultObj)
        if (countResult.length === 5) {
          resolve(countResult)
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/util/utils.js